// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3b96ea1ba2953c00ab4f168d8ad57edbb9674d28/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};